
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 2.5l10 11M9.682 9.85a2.5 2.5 0 01-3.364-3.7m2.153-.606a2.5 2.5 0 012.018 2.221m2.55 2.804C14.4 9.349 15 8 15 8s-2-4.5-7-4.5c-.433 0-.865.035-1.293.105m-2.082.682C2.077 5.577 1 8 1 8s2 4.5 7 4.5a7.378 7.378 0 003.375-.787","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    